import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';

const Body = ({ destroyedProduct, endDate, beginDate }) => (

    <div>
    {
        destroyedProduct.length <= 0 ?
        //If there's NO DATA to display
        <NoDataMsg/>
         :
         destroyedProduct.length > 0 &&
        //If there's DATA
        <div>
            <div className="row m-0">
                <div className="text-center list_header">
                    {beginDate ?
                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                        { endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b>: moment().format('MMMM Do, YYYY')}</p>
                    : ""}
                </div>
            </div>
            <div className="table-responsive">
                {
                    destroyedProduct.map((item, index) => {

                        return(
                            <div className="row m-0 mb-4 border-bottom-1  border_bottom_grey" key={index}>



                                <div className="col-lg-12 text-center daily_cash border-bottom-1 mt-1">
                                    <div className="row m-0">
                                        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 m-0 p-0 d-flex">
                                            {/* STORE CREDIT */}
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 border-right">
                                                <label>Category</label>
                                                <h3 className="m-0 grey-text">{item.category}</h3>
                                            </div>

                                            {/* DEBIT CARD */}
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                <label>SKU</label>
                                                <h3 className="m-0 grey-text">{item.sku}</h3>
                                            </div>

                                            {/* CREDIT CARD */}
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                <label>UPC</label>
                                                <h3 className="m-0 grey-text">{item.upc}</h3>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 m-0 p-0 d-flex">
                                            {/* DISCOUNTS */}
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6 col-md- m-0 p-0">
                                                <label>Unit of Measure</label>
                                                <h3 className="m-0 danger">{item.unitofmeasure}</h3>
                                            </div>

                                            {/* RECEIVED CASH */}
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6 col-md- m-0 p-0">
                                                <label>Date</label>
                                                <h3 className="m-0 green-text">{item.datedestroyed}</h3>
                                            </div>
                                            {/* PAID CASH */}
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6 m-0 p-0">
                                                <label>Time</label>
                                                <h3 className="m-0 green-text">{moment(item.timedestroyed).format("hh:mm a")}</h3>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6 m-0 p-0">
                                                <label>Quantity</label>
                                                <h3 className="m-0 green-text">{item.totalquantitydestroyed}</h3>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 m-0 p-0 d-flex">
                                            {/* CASH IN TILL */}
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 m-0 p-0">

                                                <label>Method of Destruction</label>
                                                <h3 className="m-0 green-text">{item.destroyMethod}</h3>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 m-0 p-0">

                                                <label>Done by</label>
                                                <h3 className="m-0 green-text">{item.doneBy}</h3>
                                            </div>

                                            {/* ACTUAL CASH */}
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 m-0 p-0">

                                                <label>Reason</label>
                                                <h3 className="m-0 green-text">{item.reason}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>{/* Column Icons */}


                            </div>
                        );
                    })
                }

            </div>
        </div>
        }
    </div>
);

export default Body;
